<template>
  <div id="footer">
    <v-container id="footer-container">
      <v-row>
        <v-col class="pt-4 caption">
          <span @click="enableDebugging">Made</span>
          with
          <v-icon color="error" small>mdi-heart</v-icon>
          in <a href="https://goo.gl/maps/c7qpokkHKCWP1Xdi8" title="Memmingen Google">Memmingen</a> | by <a
          href="https://www.linkedin.com/in/marco-weber/" title="Marco Weber Linkedin">Marco Weber</a> | © {{ currentYear }} Lupfen. All rights
          reserved. | v{{ currentVersion }}
        </v-col>
        <v-col class="text-right">
          <v-btn text small to="/datenschutz" color="#000000">
            Datenschutz
          </v-btn>
          |
          <v-btn text small to="/impressum" color="#000000">
            Impressum
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {AppSettings} from "@/application/AppSettings";

  export default {
    name: "Footer",
    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
      currentVersion() {
        return AppSettings.APP_VERSION;
      }
    },
    methods: {
      enableDebugging() {
        localStorage.setItem("debug", '*, -sockjs-client:*');
      }
    }
  }
</script>

<style scoped>
  #footer {
    background-color: #f9f9f9;
  }

  #footer a {
    color: #000000;
  }

  #footer-container {
    padding: 0;
    border-top: 1px solid #e0e0e0;
  }
</style>
